import { Divider, EmptyState } from '../../../../../components';
import { KNOWLEDGE_HUB_TYPE_CONFIG } from '../../../../../constants';
import { KnowledgeHubRecord } from '../../../../../services';
import { ComponentSize, KnowledgeHubRecordType } from '../../../../../types';
import { getKnowledgeHubIcon, kebabCaseToLabel } from '../../../../../utils';
import ScenarioPanelItem, { ScenarioPanelItemComponent } from './ScenarioPanelItem';

const NUM_SKELETONS = 3;

interface ScenarioPanelContentProps {
  hasSearch: boolean;
  isLoading: boolean;
  records: KnowledgeHubRecord[];
  type: KnowledgeHubRecordType;
}

const ScenarioPanelContent = ({ hasSearch, isLoading, records, type }: ScenarioPanelContentProps) => {
  const label = kebabCaseToLabel(KNOWLEDGE_HUB_TYPE_CONFIG[type].path).toLowerCase();

  const renderRecord = ({
    id,
    index,
    component,
    length,
  }: {
    id: string;
    index: number;
    component: ScenarioPanelItemComponent;
    length: number;
  }) => (
    <div key={id}>
      {component}
      {index < length - 1 && <Divider className="before:bg-base-300 after:bg-base-300" />}
    </div>
  );

  return (
    <div className="flex h-full flex-col">
      {isLoading &&
        Array.from({ length: NUM_SKELETONS }, (_, index) =>
          renderRecord({ id: index.toString(), index, component: <ScenarioPanelItem loading />, length: NUM_SKELETONS })
        )}
      {!isLoading && !records.length && (
        <EmptyState
          description={hasSearch ? `No ${label} found matching your search` : `No ${label} added yet`}
          icon={getKnowledgeHubIcon(type)}
          size={ComponentSize.X_SMALL}
        />
      )}
      {!isLoading &&
        records.map((record, index) =>
          renderRecord({
            id: record.id,
            index,
            component: <ScenarioPanelItem content={record.content} type={type} />,
            length: records.length,
          })
        )}
    </div>
  );
};

export default ScenarioPanelContent;
